import React, {useState, FC} from 'react';
import "./styles.scss";
// import Lottie from 'react-lottie';

import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  CircularProgress,
} from "@material-ui/core";

// let watchAnimationData2 = require('../jsonsPlayer/jsons/loading.json');

const Loader: FC<{ loading: boolean, style?: object }> = ({loading, children, style}) => {

    // const [animationData] = useState(watchAnimationData2);

    // const defaultOptions = {
    //     loop: true,
    //     autoplay: true,
    //     animationData: animationData,
    //     rendererSettings: {
    //         preserveAspectRatio: 'xMidYMid slice'
    //     }
    // };

    return (
      <>
        {loading ? (
          <>
            {/* @ts-ignore */}
            <Box sx={{ margin: "30px auto" }}>
              <div style={{ textAlign: "center", color: "#3640d5", direction: "rtl" }}>
                <CircularProgress />
                <Typography>در حال دریافت اطلاعات ...</Typography>
              </div>
            </Box>
          </>
        ) : (
          children
        )}
      </>
    );
};

export default Loader;